/* G36: close the keyboard user's current desktop navigation branch. */
document.addEventListener('keydown', event => {
  if (event.key !== 'Escape') return;
  const nav = event.target.closest?.('.site-navigation');
  if (!nav) return;
  const branch = event.target.closest('details[open]');
  if (!branch) return;
  event.preventDefault();
  event.stopPropagation();
  branch.querySelectorAll('details[open]').forEach(item => item.open = false);
  branch.open = false;
  branch.querySelector(':scope > summary')?.focus();
}, true);
